import {
  enhancedMakeFetchAction,
  generateEndpoint
} from '@stagapps/redux-utils'
import { API_BASE_URL, API_VERSION } from 'config/env.config'

const FETCH_UP_PORTFOLIO_API_ID = 'EMPLOYEE/FETCH_UP_PORTFOLIO_API_ID'

const apiCall = enhancedMakeFetchAction(
  FETCH_UP_PORTFOLIO_API_ID,
  ({ id, ...params }) => ({
    endpoint: generateEndpoint({
      host: `${API_BASE_URL}/investcore-api/app/${API_VERSION}/user-programs/${id}/portfolio`,
      params
    }),
    method: 'GET'
  })
)

export default apiCall
